<template>
  <!-- prettier-ignore -->
  <svg aria-hidden="true" focusable="false" width="11" height="19" viewBox="0 0 11 19" xmlns="http://www.w3.org/2000/svg"><path d="M.4 18.6c-.5-.5-.5-1.2 0-1.7l7.1-7.4L.4 2C-.1 1.7-.1 1 .3.5V.4C1-.1 1.8-.1 2.2.4l8.9 9-8.9 9.2c-.5.5-1.2.5-1.7 0Z" fill="currentColor" fill-rule="nonzero"/></svg>
</template>
